import React, { useMemo, useRef, useState } from 'react';
import { connect, useIntl } from 'umi';
import { Layout, Col, Row } from 'tea-component';
import FunnelFilter from '@/pages/dashboard/filterPageComponents/funnel/funnelFilter';
import FunnelStep from './components/FunnelStep';
import FunnelCard from './components/FunnelCard';
import TrendStep from './components/TrendStep';
import Trend from './components/Trend';
import FunnelTable from './components/FunnelTable';
import { useBuriedPoint } from '@/pages/home/utils/customHook';

import '@/pages/dashboard/assets/scss/page/Funnel/registerFunnel.scss';
import MarqueeInfo from '../../components/MarqueeInfo';
import { POE_DEMO_GAME_CODE_LIST } from '../../_config/constant';
import { SubTitle } from '../../components/SubTitle';

const { Content } = Layout;
const RegisterFunnel = (props: any) => {
  const { gameCode, explainInfo, gameConfig, dataFrame } = props;
  const { formatMessage } = useIntl();
  const [formValue, setFormValue] = useState(null);
  const selectorDataRef = useRef(null);
  const [filterLoading, setFilterLoading] = useState(true);
  const pageType = 'mobile';
  const default_select = gameConfig?.page_selector?.find((item: any) => item?.path === '/funnel/registerFunnel')?.filters;
  const hasAddInput = useMemo(() => {
    return default_select?.filter(item => item?.visible === 1)?.map(v => v?.key)?.includes('store_channel');
  }, [gameConfig]);

  const isPoeDemo = POE_DEMO_GAME_CODE_LIST?.includes(gameCode);
  const isCasual = dataFrame === 'casual';

  const firstStepId = useMemo(() => {
    const stageList = formValue?.stageList || [];
    return stageList?.find((item: any) => item?.stage_no === '1')?.stage_id || 'app_launch';
  }, [formValue]);

  const handleInit = (filterValue: any) => {
    setFormValue(filterValue);
    setFilterLoading(false);
  };

  const getSelectorData = (data: any) => {
    selectorDataRef.current = data || {};
  };

  const handleFilterChange = (filterValue: any) => {
    setFormValue(filterValue);
  };
  // 打点信息
  const logObj = {
    pageId: '202801',
    pageName: 'registerFunnel',
    extInfo: 'registerFunnel',
    pagePath: '/funnel/registerFunnel',
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };
  useBuriedPoint(logObj);

  return (
    <>
      <Content className='dbd-register-funnel dbd-scroll-body'>
        <Content.Header title={isPoeDemo ? formatMessage({ id: 'funnel_register_funnel_poe' }) : formatMessage({ id: isCasual ? 'funnel_register_funnel_casual' : 'funnel_register_funnel' })} subtitle={<SubTitle/>} />
        <Content.Body full>
          <MarqueeInfo pagePath={logObj.pagePath} />
          <FunnelFilter
            pageType={pageType}
            defaultSelect={default_select}
            openSticky={true}
            filterConfirm={handleFilterChange}
            filterReset={handleFilterChange}
            filterInit={handleInit}
            hasAddInput={hasAddInput}
            getSelectorData={getSelectorData}
            buttonLogConfig={{ pageId: '202801', confirmButtonId: '202801001', resetButtonId: '202801002' }}
          />
          <FunnelStep pageType={pageType} filterLoading={filterLoading} formValue={formValue} gameCode={gameCode} />
          <Row className='register-funnel-margin'>
            <Col>
              <FunnelCard pageType={pageType} filterLoading={filterLoading} formValue={formValue} gameCode={gameCode} isPoeDemo={isPoeDemo}/>
            </Col>
          </Row>
          <Row className='register-funnel-margin'>
            <Col span={12}>
              <TrendStep
                pageType={pageType}
                firstStepId={firstStepId}
                hasAddInput={hasAddInput}
                defaultSelect={default_select}
                formValue={formValue}
                gameCode={gameCode}
                filterLoading={filterLoading}
                selectorData={selectorDataRef.current}
              />
            </Col>
            <Col span={12}>
              <Trend
                pageType={pageType}
                formValue={formValue}
                gameCode={gameCode}
                filterLoading={filterLoading}
              />
            </Col>
          </Row>
          <FunnelTable
            pageType={pageType}
            firstStepId={firstStepId}
            hasAddInput={hasAddInput}
            defaultSelect={default_select}
            filterValue={{ ...formValue, timeType: 'Day' }}
            filterLoading={filterLoading}
            gameCode={gameCode}
            explainInfo={explainInfo}
          />
        </Content.Body>
      </Content>
    </>
  );
};

export default connect((state: any) => ({
  gameConfig: state.dashboardSetting.gameConfig,
  serviceData: state.overview?.data,
  gameCode: state.dashboard?.currentGame?.game_code,
  dataFrame: state.dashboard?.currentGame?.data_frame,
  explainInfo: state.dashboard?.explainInfo,
}))(RegisterFunnel);
